import { FC, ReactNode } from 'react';
import { useQuery } from 'react-query';
import { useRootContext } from '../../../../../../../../../components/RootContainer';
import SelectMultiple from '../../../../../../../../../components/SelectMultiple';

export const StateField: FC<{
  value: Array<string> | undefined;
  onChange: (value: Array<string> | undefined) => void;
  error?: ReactNode;
}> = ({ value, onChange, error }) => {
  const {
    HotelApi: {
      reservations: {
        reservation: {
          common: { getArrivalReservationStates },
        },
      },
    },
  } = useRootContext();

  const { data, isLoading } = useQuery({
    queryKey: ['getArrivalReservationStates'],
    queryFn: () => getArrivalReservationStates(),
  });

  return (
    <SelectMultiple
      sx={{ width: '100%' }}
      variant="filled"
      inputLabel={'State'}
      options={data || []}
      getOptionLabel={item => item.name}
      getOptionValue={item => item.system_value}
      value={value ?? []}
      onChange={newValue => {
        onChange(newValue as Array<string>);
      }}
    />
  );
};
